import { render } from "./AiDashboard.vue?vue&type=template&id=73d1c9f0"
import script from "./AiDashboard.vue?vue&type=script&lang=js"
export * from "./AiDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__